/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../src/app/document-hitlist/components/document-view.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../src/app/document-hitlist/services/document-hitlist-api.service';
import * as import10 from '../../../../../src/app/document-hitlist/services/document-hitlist-config.service';
import * as import11 from './document-view.component.css.shim.ngstyle';
import * as import12 from 'ng2-translate/src/translate.pipe';
import * as import13 from '@angular/core/src/linker/view_container';
import * as import14 from 'ng2-translate/src/translate.service';
import * as import15 from '../../../../../src/app/shared/components/loading.component';
import * as import16 from '../../shared/components/loading.component.ngfactory';
import * as import17 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import18 from '../../../../../src/app/document-hitlist/pipes/trust-html.pipe';
import * as import19 from '../../../../../src/app/document-hitlist/pipes/trust-resource-url.pipe';
import * as import20 from '@angular/core/src/linker/template_ref';
import * as import21 from '@angular/platform-browser/src/security/dom_sanitization_service';
import * as import22 from '@angular/common/src/directives/ng_if';
import * as import23 from '@angular/core/src/security';
export class Wrapper_DocumentViewComponent {
  /*private*/ _eventHandler:Function;
  context:import0.DocumentViewComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  subscription0:any;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this.context = new import0.DocumentViewComponent(p0,p1);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_isMobileBrowser(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.isMobileBrowser = currValue;
      this._expr_0 = currValue;
    }
  }
  check_document(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.document = currValue;
      this._expr_1 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    if ((eventName == 'document:keydown')) {
      const pd_sub_0:any = ((<any>this.context.keydownHandle($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.close.subscribe(_eventHandler.bind(view,'close'))); }
  }
}
var renderType_DocumentViewComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_DocumentViewComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.DocumentViewComponent>;
  _DocumentViewComponent_0_3:Wrapper_DocumentViewComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DocumentViewComponent_Host0,renderType_DocumentViewComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'obpa-document-view',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_DocumentViewComponent0(this.viewUtils,this,0,this._el_0);
    this._DocumentViewComponent_0_3 = new Wrapper_DocumentViewComponent(this.injectorGet(import9.DocumentHitlistApiService,this.parentIndex),this.injectorGet(import10.DocumentHitlistConfigService,this.parentIndex));
    this.compView_0.create(this._DocumentViewComponent_0_3.context);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'keydown','document'),this.eventHandler(this.handleEvent_0));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),[disposable_0]);
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._DocumentViewComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.DocumentViewComponent) && (0 === requestNodeIndex))) { return this._DocumentViewComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DocumentViewComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._DocumentViewComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.compView_0.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DocumentViewComponent_0_3.handleEvent(eventName,$event) && result);
    return result;
  }
}
export const DocumentViewComponentNgFactory:import8.ComponentFactory<import0.DocumentViewComponent> = new import8.ComponentFactory<import0.DocumentViewComponent>('obpa-document-view',View_DocumentViewComponent_Host0,import0.DocumentViewComponent);
const styles_DocumentViewComponent:any[] = [import11.styles];
class View_DocumentViewComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import12.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import13.ViewContainer) {
    super(View_DocumentViewComponent1,renderType_DocumentViewComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'button',new import3.InlineArray4(4,'class','btn btn-link navbar-btn','type','button'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','glyphicon glyphicon-download-alt'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_0));
    this._pipe_translate_0 = new import12.TranslatePipe(this.parentView.injectorGet(import14.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('DOWNLOAD NATIVE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setElementProperty(this._el_0,'title',currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.onDocumentDownloadNative()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_DocumentViewComponent2 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import15.LoadingComponent>;
  _LoadingComponent_0_3:import16.Wrapper_LoadingComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import13.ViewContainer) {
    super(View_DocumentViewComponent2,renderType_DocumentViewComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'obpa-loading',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import16.View_LoadingComponent0(this.viewUtils,this,0,this._el_0);
    this._LoadingComponent_0_3 = new import16.Wrapper_LoadingComponent();
    this.compView_0.create(this._LoadingComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import15.LoadingComponent) && (0 === requestNodeIndex))) { return this._LoadingComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._LoadingComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_DocumentViewComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.Emulated,styles_DocumentViewComponent,{});
export class View_DocumentViewComponent0 extends import2.AppView<import0.DocumentViewComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _text_21:any;
  _anchor_22:any;
  /*private*/ _vc_22:import13.ViewContainer;
  _TemplateRef_22_5:any;
  _NgIf_22_6:import17.Wrapper_NgIf;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _anchor_34:any;
  /*private*/ _vc_34:import13.ViewContainer;
  _TemplateRef_34_5:any;
  _NgIf_34_6:import17.Wrapper_NgIf;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _text_38:any;
  _text_39:any;
  _text_40:any;
  _text_41:any;
  /*private*/ _expr_48:any;
  _pipe_trustHtml_0:import18.TrustHtmlPipe;
  _pipe_trustHtml_0_0:any;
  /*private*/ _expr_51:any;
  _pipe_translate_1:import12.TranslatePipe;
  /*private*/ _expr_53:any;
  _pipe_translate_2:import12.TranslatePipe;
  /*private*/ _expr_55:any;
  /*private*/ _expr_56:any;
  _pipe_trustResourceUrl_3:import19.TrustResourceUrlPipe;
  _pipe_trustResourceUrl_3_0:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DocumentViewComponent0,renderType_DocumentViewComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_48 = import1.UNINITIALIZED;
    this._expr_51 = import1.UNINITIALIZED;
    this._expr_53 = import1.UNINITIALIZED;
    this._expr_55 = import1.UNINITIALIZED;
    this._expr_56 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','docview-background'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','docview-container'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','docview-panel'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','docview-panel-header'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','navbar navbar-default'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','navbar-header pull-left'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'span',new import3.InlineArray2(2,'class','navbar-brand docview-title'),(null as any));
    this._text_13 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_14 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','navbar-header pull-right'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                        ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'button',new import3.InlineArray4(4,'class','btn btn-link navbar-btn','type','button'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n                            ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_17,'span',new import3.InlineArray2(2,'class','glyphicon glyphicon-new-window'),(null as any));
    this._text_20 = this.renderer.createText(this._el_17,'\n                        ',(null as any));
    this._text_21 = this.renderer.createText(this._el_15,'\n                        ',(null as any));
    this._anchor_22 = this.renderer.createTemplateAnchor(this._el_15,(null as any));
    this._vc_22 = new import13.ViewContainer(22,15,this,this._anchor_22);
    this._TemplateRef_22_5 = new import20.TemplateRef_(this,22,this._anchor_22);
    this._NgIf_22_6 = new import17.Wrapper_NgIf(this._vc_22.vcRef,this._TemplateRef_22_5);
    this._text_23 = this.renderer.createText(this._el_15,'\n                        ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_15,'button',new import3.InlineArray4(4,'class','btn btn-link navbar-btn','type','button'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'\n                            ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_24,'span',new import3.InlineArray2(2,'class','glyphicon glyphicon-remove'),(null as any));
    this._text_27 = this.renderer.createText(this._el_24,'\n                        ',(null as any));
    this._text_28 = this.renderer.createText(this._el_15,'\n                    ',(null as any));
    this._text_29 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_30 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_31 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','docview-panel-body'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n                ',(null as any));
    this._anchor_34 = this.renderer.createTemplateAnchor(this._el_32,(null as any));
    this._vc_34 = new import13.ViewContainer(34,32,this,this._anchor_34);
    this._TemplateRef_34_5 = new import20.TemplateRef_(this,34,this._anchor_34);
    this._NgIf_34_6 = new import17.Wrapper_NgIf(this._vc_34.vcRef,this._TemplateRef_34_5);
    this._text_35 = this.renderer.createText(this._el_32,'\n                ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_32,'iframe',new import3.InlineArray2(2,'class','docview-frame'),(null as any));
    this._text_37 = this.renderer.createText(this._el_32,'\n            ',(null as any));
    this._text_38 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_39 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_40 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_41 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_0));
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_2));
    this._pipe_trustHtml_0 = new import18.TrustHtmlPipe(this.parentView.injectorGet(import21.DomSanitizer,this.parentIndex));
    this._pipe_trustHtml_0_0 = import3.pureProxy1(this._pipe_trustHtml_0.transform.bind(this._pipe_trustHtml_0));
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_17,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_17));
    this._pipe_translate_1 = new import12.TranslatePipe(this.parentView.injectorGet(import14.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_24,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_24));
    this._pipe_translate_2 = new import12.TranslatePipe(this.parentView.injectorGet(import14.TranslateService,this.parentIndex),this.ref);
    this._pipe_trustResourceUrl_3 = new import19.TrustResourceUrlPipe(this.parentView.injectorGet(import21.DomSanitizer,this.parentIndex));
    this._pipe_trustResourceUrl_3_0 = import3.pureProxy1(this._pipe_trustResourceUrl_3.transform.bind(this._pipe_trustResourceUrl_3));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._text_21,
      this._anchor_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._text_28,
      this._text_29,
      this._text_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._anchor_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._text_38,
      this._text_39,
      this._text_40,
      this._text_41
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import20.TemplateRef) && (22 === requestNodeIndex))) { return this._TemplateRef_22_5; }
    if (((token === import22.NgIf) && (22 === requestNodeIndex))) { return this._NgIf_22_6.context; }
    if (((token === import20.TemplateRef) && (34 === requestNodeIndex))) { return this._TemplateRef_34_5; }
    if (((token === import22.NgIf) && (34 === requestNodeIndex))) { return this._NgIf_34_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_22_0_0:any = this.context.model.showDownloadNative;
    this._NgIf_22_6.check_ngIf(currVal_22_0_0,throwOnChange,false);
    this._NgIf_22_6.ngDoCheck(this,this._anchor_22,throwOnChange);
    const currVal_34_0_0:boolean = !this.context.model.viewerVisible;
    this._NgIf_34_6.check_ngIf(currVal_34_0_0,throwOnChange,false);
    this._NgIf_34_6.ngDoCheck(this,this._anchor_34,throwOnChange);
    this._vc_22.detectChangesInNestedViews(throwOnChange);
    this._vc_34.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_48:any = valUnwrapper.unwrap(import3.castByValue(this._pipe_trustHtml_0_0,this._pipe_trustHtml_0.transform)(((this.context.document == null)? (null as any): this.context.document.docName)));
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_48,currVal_48))) {
      this.renderer.setElementProperty(this._el_12,'innerHTML',this.viewUtils.sanitizer.sanitize(import23.SecurityContext.HTML,currVal_48));
      this._expr_48 = currVal_48;
    }
    valUnwrapper.reset();
    const currVal_51:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('OPEN IN NEW WINDOW')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_51,currVal_51))) {
      this.renderer.setElementProperty(this._el_17,'title',currVal_51);
      this._expr_51 = currVal_51;
    }
    valUnwrapper.reset();
    const currVal_53:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('CLOSE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_53,currVal_53))) {
      this.renderer.setElementProperty(this._el_24,'title',currVal_53);
      this._expr_53 = currVal_53;
    }
    const currVal_55:boolean = !this.context.model.viewerVisible;
    if (import3.checkBinding(throwOnChange,this._expr_55,currVal_55)) {
      this.renderer.setElementAttribute(this._el_36,'data-hidden',((currVal_55 == null)? (null as any): currVal_55.toString()));
      this._expr_55 = currVal_55;
    }
    valUnwrapper.reset();
    const currVal_56:any = valUnwrapper.unwrap(import3.castByValue(this._pipe_trustResourceUrl_3_0,this._pipe_trustResourceUrl_3.transform)(this.context.model.viewerUri));
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_56,currVal_56))) {
      this.renderer.setElementProperty(this._el_36,'src',this.viewUtils.sanitizer.sanitize(import23.SecurityContext.RESOURCE_URL,currVal_56));
      this._expr_56 = currVal_56;
    }
  }
  destroyInternal():void {
    this._vc_22.destroyNestedViews();
    this._vc_34.destroyNestedViews();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 22)) { return new View_DocumentViewComponent1(this.viewUtils,this,22,this._anchor_22,this._vc_22); }
    if ((nodeIndex == 34)) { return new View_DocumentViewComponent2(this.viewUtils,this,34,this._anchor_34,this._vc_34); }
    return (null as any);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.onClose()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>$event.stopPropagation()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_17(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.onDocumentOpenInNewWindow()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_24(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.onClose()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./$$_gendir/src/app/document-hitlist/components/document-view.component.ngfactory.ts